import React, { useContext, useEffect } from "react";
import LoaderLayout from "../../../components/Layout/LoaderLayout";
import { UserContext } from "../../../Context/UserContextAPI";
import useQueryFetch from "../../../hooks/useQueryFetch";
import request from "../../../utils/request";
import SettingsFormContainer from "./SettingsFormContainer";
import { useQueryClient } from "@tanstack/react-query";
import axios from "axios";

const SettingsPage = () => {
  const { accessPerm } = useContext(UserContext);
  const queryClient = useQueryClient();

  const { data, isLoading, refetch } = useQueryFetch("settings", () =>
    request.getOne("settings", 1)
  );

  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = `${process.env.REACT_APP_UPLOAD_URL}/${data?.fav_image}`;
  }, [data?.fav_image]); // Add data?.fav_image as depe</div>ndency

  const formDataConverter = (values) => {
    const formData = new FormData();

    Object.keys(values).forEach((data) => {
      formData.append(data, values[data]);
    });
    return formData;
  };

  const submitFormHandler = async (values) => {
    try {
      const res = await request.updateOne(
        "settings",
        "",
        formDataConverter(values),
        () => {
          queryClient.invalidateQueries(["settings"]);
        },
        {
          "Content-Type": "multipart/form-data",
        }
      );
      console.log(res);
      console.log(res.data);
    } catch (error) {
      console.log(error);
      // toast.error(
      //   error?.response?.data?.data ||
      //     "Something went wrong! or no folder found"
      // );
    }
  };

  return (
    <LoaderLayout isLoading={isLoading}>
      <div className="row text-dark">
        <div className="col-xl-12 mx-auto">
          <div className="card">
            <div className="card-body">
              <SettingsFormContainer
                settingsData={data}
                submitFormHandler={submitFormHandler}
              />
            </div>
          </div>
        </div>
      </div>
    </LoaderLayout>
  );
};

export default SettingsPage;
